const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFCE47"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBB500"
    },
    cx: 256,
    cy: 256,
    r: 227.788
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE29E"
    },
    d: "M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE47"
    },
    d: "M256,28.212C130.196,28.212,28.212,130.196,28.212,256S130.196,483.788,256,483.788V28.212z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE29E"
    },
    d: "M234.223,464.557c-14.574-1.505-29.007-4.551-42.9-9.051l9.661-29.821 c11.802,3.824,24.069,6.411,36.46,7.691L234.223,464.557z M278.006,464.533l-3.253-31.178c12.384-1.293,24.645-3.892,36.443-7.728 l9.692,29.811C307.001,459.954,292.574,463.013,278.006,464.533z M151.263,437.681c-12.644-7.304-24.572-15.97-35.451-25.758 l20.965-23.304c9.259,8.33,19.409,15.704,30.166,21.918L151.263,437.681z M360.926,437.573l-15.707-27.128 c10.749-6.223,20.888-13.607,30.137-21.944l20.989,23.283C385.475,421.581,373.559,430.258,360.926,437.573z M86.463,379.397 c-8.622-11.828-16.016-24.583-21.973-37.911l28.618-12.793c5.066,11.33,11.352,22.177,18.687,32.238L86.463,379.397z  M425.659,379.229l-25.348-18.441c7.327-10.072,13.606-20.927,18.659-32.267l28.631,12.761 C441.657,354.62,434.274,367.388,425.659,379.229z M50.907,299.797c-3.026-14.235-4.568-28.891-4.584-43.564L77.67,256.2 c0.014,12.497,1.325,24.972,3.899,37.079L50.907,299.797z M461.141,299.569l-30.67-6.485c2.56-12.107,3.858-24.584,3.858-37.084 v-0.375l31.347-0.111v0.487C465.677,270.675,464.15,285.333,461.141,299.569z M81.488,219.109l-30.676-6.45 c3.01-14.316,7.549-28.354,13.492-41.727l28.646,12.729C87.901,195.022,84.045,206.948,81.488,219.109z M430.389,218.529 c-2.598-12.152-6.493-24.063-11.577-35.403l28.604-12.824c5.985,13.349,10.569,27.37,13.628,41.675L430.389,218.529z  M111.572,151.373L86.203,132.96c8.581-11.822,18.433-22.786,29.281-32.588l21.014,23.26 C127.262,131.977,118.876,141.31,111.572,151.373z M400.089,150.908c-7.335-10.038-15.751-19.345-25.013-27.658l20.94-23.328 c10.879,9.767,20.766,20.698,29.384,32.492L400.089,150.908z M166.611,101.655l-15.738-27.11 c12.663-7.351,26.127-13.378,40.016-17.912l9.727,29.8C188.815,90.285,177.375,95.406,166.611,101.655z M344.887,101.365 c-10.786-6.214-22.246-11.298-34.06-15.111l9.628-29.832c13.906,4.487,27.391,10.47,40.081,17.782L344.887,101.365z  M237.052,78.664l-3.288-31.173c14.441-1.523,29.333-1.547,43.782-0.071l-3.187,31.185 C262.052,77.346,249.35,77.367,237.052,78.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE29E"
    },
    d: "M271.673,307.984V204.016c10.53,5.624,17.715,16.722,17.715,29.47h31.347 c0-30.292-20.917-55.78-49.062-62.807v-33.45h-31.347v33.45c-28.145,7.027-49.062,32.515-49.062,62.807v45.027 c0,30.292,20.917,55.78,49.062,62.807v33.45h31.347v-33.45c28.145-7.027,49.062-32.515,49.062-62.807h-31.347 C289.389,291.262,282.204,302.36,271.673,307.984z M222.611,278.513v-45.027c0-12.749,7.185-23.847,17.715-29.47v103.967 C229.796,302.36,222.611,291.262,222.611,278.513z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCoin);
export default __webpack_public_path__ + "static/media/credit_coin.a8e78ba4f91a6a21d3244d05ce6797ad.svg";
export { ForwardRef as ReactComponent };